import React, { FC, useState } from "react";
import styled from "@emotion/styled";
import RightSelect from "./components/RightSelect";
import ContentBody from "./components/ContentBody";
import { useGetReportOverview } from "hooks/useDashboard";
interface CardReportOverallProps {
  selectPeriod: string;
  setSelectPeriod: (value: string) => void;
  daterangePicker: [string, string]
}

const CardReportOverall: FC<CardReportOverallProps> = ({
  setSelectPeriod,
  selectPeriod,
  daterangePicker
}) => {

  const { data, isLoading } = useGetReportOverview({ period: selectPeriod , start_date: daterangePicker[0], end_date: daterangePicker[1]  });

  return (
    <CardWrapper>
      <CardHeaderWrapper>
        <WrapperTextHeader>ภาพรวม</WrapperTextHeader>
      </CardHeaderWrapper>
      <RowPercentWrapper>
      </RowPercentWrapper>
      <ContentBody data={data?.data} />
    </CardWrapper>
  );
};

export default CardReportOverall;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 20px 20px 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

const CardHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;


const RowPercentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const TextPositive = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #00b300;
  background-color: #ffffff;
`;

const WrapperIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  height: 19px;
`;

const WrapperTextPercent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 19px;
`;

const WrapperTextHeader = styled.p`
  font-size: 25px;
  font-weight: 400;

  @media (min-width: 1920px) {
    font-size: 23px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    font-size: 21px;
  }
  @media (min-width: 481px) and (max-width: 767px) {
    font-size: 19px;
  }
  @media (max-width: 480px) {
    font-size: 17px;
  }
  @media (min-width: 481px) and (max-width: 991px) {
    font-size: 18px;
  }
`;
